import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Headset, Zap, ClipboardList, User } from 'lucide-react';
import { useTranslation } from 'react-i18next'; // i18n hook import
import './BottomBar.css';

const BottomBar = () => {
  const { t } = useTranslation(); // Translation hook
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // JSON کی Keys کے ساتھ نام تبدیل کیے
  const navItems = [
    { name: t('nav_home'), icon: <Home size={22} />, path: '/' },
    { name: t('nav_service'), icon: <Headset size={22} />, path: '/service' },
    { name: t('nav_grabbing'), icon: <Zap size={28} />, path: '/grabbing', special: true },
    { name: t('nav_record'), icon: <ClipboardList size={22} />, path: '/record' },
    { name: t('nav_mine'), icon: <User size={22} />, path: '/mine' },
  ];

  return (
    <div className="bottom-nav">
      {navItems.map((item) => (
        <div 
          key={item.name} 
          className={`nav-item ${isActive(item.path) ? 'active' : ''} ${item.special ? 'special-item' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <div className="icon-wrapper">
            {item.icon}
          </div>
          <span className="nav-label">{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default BottomBar;